import { startWith, map, flatMap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { CompanysitesService } from '../../company-sites/company-sites.service';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.css']
})
export class InventoryComponent implements OnInit {

  layoutSetup: Observable<any>;

  constructor(private route: ActivatedRoute, private siteService: CompanysitesService) {

  }

  ngOnInit() {
    let siteIdObs = this.route.params.pipe(map(params => {
      console.log(params)
      return {
        siteId: params['siteId'],
        systemId: params['systemId']
      };
    }));

    this.layoutSetup = combineLatest(siteIdObs).pipe(map(values => {
      return {
        links: [
          { name: "Management", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/inventory" + "/stockcontroll" },
          { name: "Extra Management", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/inventory" + "/extra-stockcontroll" },
          { name: "Svinn", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/inventory" + "/svinn" },
          { name: "Links", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/inventory" + "/links" },
          { name: "Auto filler", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/inventory" + "/stockfiller" },

        ]

      };
    }));
  }

}
